import { CPTCodeDTO } from 'utils/lib/types/api/chart-data/chart-data.types';

export const SURGICAL_HISTORY_OPTIONS: CPTCodeDTO[] = [
  { display: 'Adenoidectomy', code: '42830' },
  { display: 'Appendectomy', code: '44950' },
  { display: 'C-section', code: '59510' },
  { display: 'Circumcision', code: '54150' },
  { display: 'Cleft Lip/Palate Repair', code: '42200' },
  { display: 'Cyst removed', code: '97139' },
  { display: 'Dental/Oral Surgery', code: '41899' },
  { display: 'Ear tube placement', code: '69436' },
  { display: 'Elbow/Hand/Arm Surgery', code: '24999' },
  { display: 'Feeding tube', code: '43246' },
  { display: 'Foot/Ankle Surgery', code: '27899' },
  { display: 'Frenotomy', code: '41010' },
  { display: 'Gallbladder removal', code: '47600' },
  { display: 'Heart/Cardiac surgery', code: '33999' },
  { display: 'Hemangioma', code: '17106' },
  { display: 'Hernia Repair', code: '49617' },
  { display: 'Hydrocele Repair', code: '55060' },
  { display: 'Hypospadias repair', code: '53450' },
  { display: 'Kidney surgery', code: '50540' },
  { display: 'Knee Surgery', code: '29850' },
  { display: 'Orchiectomy (Testicle Removal)', code: '54520' },
  { display: 'Other Eye surgery', code: '65799' },
  { display: 'Pyloromyotomy', code: '67599' },
  { display: 'Sinus surgery', code: '43520' },
  { display: 'Splenectomy', code: '31299' },
  { display: 'Tear Duct Eye surgery', code: '38100' },
  { display: 'Tonsillectomy and adenoidectomy', code: '68899' },
  { display: 'Undescended Testicle Repair', code: '42820' },
  { display: 'Ventriculoperitoneal shunt placement', code: '54640' },
  { display: 'Wisdom teeth removal', code: '75809' },
  { display: 'Other', code: '41899' },
];
